export default __webpack_public_path__ + "static/media/Shapes_17.f23e808e.png";